import React, { useEffect, useState } from 'react';
import { Eye } from 'lucide-react';
import api from '../utils/api';

// Inline version for Navbar (non-floating)
export const InlineVisitorCounter = () => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    incrementVisitor();
  }, []);

  const incrementVisitor = async () => {
    try {
      const response = await api.post('/visitor-count');
      setCount(response.data.count);
    } catch (error) {
      try {
        const response = await api.get('/visitor-count');
        setCount(response.data.count);
      } catch (err) {
        console.error('Failed to get visitor count:', err);
      }
    }
  };

  const formatCount = (num) => {
    return num.toString().padStart(9, '0');
  };

  return (
    <div className="flex items-center gap-1.5 px-2 py-1 sm:px-3 sm:py-1.5 bg-white/5 rounded-full border border-white/10" data-testid="visitor-counter">
      <Eye className="w-3 h-3 sm:w-4 sm:h-4 text-primary" />
      <span className="text-xs sm:text-sm font-mono text-primary font-semibold" data-testid="visitor-count">
        {formatCount(count)}
      </span>
    </div>
  );
};

// Legacy floating version (kept for backwards compatibility but not used)
const VisitorCounter = () => {
  return null; // No longer renders floating version
};

export default VisitorCounter;
